import { useEffect, useState } from "react";
import { useGetUserQuery } from "../../services/msgraph/msGraphApi";
import de from 'date-fns/locale/de';
import enGB from 'date-fns/locale/en-GB';

interface useGetLanguageOutput {
    language: string,
    languageShort: string,
    locale: any,
}

interface IDictionary {
    [index: string]: any;
}
const locs = {
    'en': enGB,
    'de': de,
    'de-DE': de,
    'de-AT': de,
    'default': enGB,
} as IDictionary

function useGetLanguage(): useGetLanguageOutput {

    const { data, isLoading, isSuccess, error } = useGetUserQuery();
    const [language, setLanguage] = useState('en');
    const [loc, setLoc] = useState(locs['default']);
    const [languageShort, setLanguageShort] = useState('en');

    useEffect(() => {
        if ( data && data.preferredLanguage) {
            if ( data.preferredLanguage) {
                setLanguage(data.preferredLanguage);
                setLoc(locs[data.preferredLanguage] ?? locs['default']);
                setLanguageShort(data.preferredLanguage.split('-') ? data.preferredLanguage.split('-')[0] : data.preferredLanguage);
            }
        }
        else {
            //if ( navigator.userLanguage)
            // setLanguage(navigator.userLanguage);
            // else 
             setLanguage(navigator.language);
             setLoc(locs[navigator.language] ?? locs['default']);
             setLanguageShort(navigator.language.split('-') ? navigator.language.split('-')[0] : navigator.language);
        }
        
    },[data]);


    return {
        language: language,
        languageShort: languageShort,
        locale: loc
    }
}

export default useGetLanguage